import { render, staticRenderFns } from "./ObiHeader.vue?vue&type=template&id=6914105b&scoped=true&"
import script from "./ObiHeader.vue?vue&type=script&lang=js&"
export * from "./ObiHeader.vue?vue&type=script&lang=js&"
import style0 from "./ObiHeader.vue?vue&type=style&index=0&id=6914105b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6914105b",
  null
  
)

export default component.exports